import { HTMLAttributes } from "react";

interface HeartIconProps extends HTMLAttributes<SVGElement> {}

const HeartIcon = ({ ...props }: HeartIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.99966 2.247C2.11224 3.51087 0.723159 7.7815 1.91237 11.5119C2.99695 14.668 5.46167 16.6773 7.75 18.9945C9.01756 20.0261 10.3488 20.9755 11.7359 21.8369L12.0057 22L12.2655 21.8369C14.6646 20.3471 16.8964 18.5937 18.9211 16.6082C20.3445 15.1782 21.4281 13.435 22.089 11.5119C23.2782 7.7815 21.8791 3.51087 17.9917 2.247C15.9485 1.58508 13.7179 2.698 11.9957 4C10.2741 2.69642 8.04273 1.58336 5.99966 2.247Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HeartIcon;
